export const TRANSLATION_KEYS = {
    Heading: "ticketViewPage.heading",
    SecondaryHeading: "ticketViewPage.secondaryHeading",
    BreadcrumbTicketHeading: "ticketPage.heading",
    StatusCanceledMessage: "ticketViewPage.statusCanceledMessage",
    StatusCloseMessage: "ticketViewPage.statusCloseMessage",
    StatusDeletedMessage: "ticketViewPage.statusDeletedMessage",
    RequestedByLabel: "ticketDetailsPage.requestedByLabel",
    CreatedAtLabel: "ticketDetailsPage.createdAtLabel",
    StatusLabel: "ticketDetailsPage.statusLabel",
    CanceledAtLabel: "ticketDetailsPage.canceledAtLabel",
    ClosedAtLabel: "ticketDetailsPage.closedAtLabel",
    DeletedAtLabel: "ticketDetailsPage.deletedAtLabel"
};